import axios from 'axios';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface VesselSearchResult {
  registreringsmerke: string;
  vessel_name: string;
  vessel_display: string;
}

export interface LocationSearchResult {
  location_id: string;
  location_name: string;
  landing_municipality?: string;
  landing_county?: string;
}

export interface CatchRecord {
  dokumentnummer?: string;
  registreringsmerke?: string;
  vessel_name?: string;
  vessel_display?: string;
  date: string;
  landing_municipality?: string;
  species?: string;
  weight_kg?: number;
  value_nok?: number;
  quantity?: number;
  product_condition?: string;
  quality?: string;
}

export interface VesselCatchResponse {
  vessel_id: string;
  vessel_name: string;
  vessel_display?: string;
  daily: CatchRecord[];
  total_weight_kg: number;
  total_value_nok: number;
  species_breakdown: Record<string, { weight_kg: number; value_nok: number }>;
  locations_supplied: string[];
}

export interface LocationIntakeResponse {
  location_id: string;
  location_name: string;
  daily: CatchRecord[];
  total_weight_kg: number;
  total_value_nok: number;
  species_breakdown: Record<string, { weight_kg: number; value_nok: number }>;
  vessel_breakdown: any[];
}

export const vesselService = {
  search: async (query: string, limit: number = 20): Promise<VesselSearchResult[]> => {
    const response = await api.get('/vessel/search', {
      params: { query, limit },
    });
    return response.data.results;
  },

  getCatch: async (
    vesselId: string,
    fromDate: string,
    toDate: string,
    species: string = '*'
  ): Promise<VesselCatchResponse> => {
    const response = await api.get(`/vessel/${vesselId}/catch`, {
      params: { from_date: fromDate, to_date: toDate, species },
    });
    return response.data;
  },

  autocomplete: async (query: string = '', limit: number = 20): Promise<VesselSearchResult[]> => {
    const response = await api.get('/autocomplete/vessels', {
      params: { query, limit },
    });
    return response.data.results;
  },
};

export const locationService = {
  search: async (query: string, limit: number = 20): Promise<LocationSearchResult[]> => {
    const response = await api.get('/location/search', {
      params: { query, limit },
    });
    return response.data.results;
  },

  getIntake: async (
    locationId: string,
    fromDate: string,
    toDate: string,
    species: string = '*'
  ): Promise<LocationIntakeResponse> => {
    const response = await api.get(`/location/${locationId}/intake`, {
      params: { from_date: fromDate, to_date: toDate, species },
    });
    return response.data;
  },

  autocomplete: async (query: string = '', limit: number = 20): Promise<LocationSearchResult[]> => {
    const response = await api.get('/autocomplete/locations', {
      params: { query, limit },
    });
    return response.data.results;
  },
};

export const utilService = {
  getSpecies: async (): Promise<string[]> => {
    const response = await api.get('/autocomplete/species');
    return response.data.species;
  },

  triggerETL: async () => {
    const response = await api.post('/etl/trigger');
    return response.data;
  },
};
